import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import Profile from './Profile';

const Profiles = () => {
  return (
    <div>
      <div className='  p-5 lg:p-12 bg-waves bg-cover lg:px-36 h-full space-y-3'>
        <motion.div
          animate={{ y: 0 }}
          initial={{ y: 400 }}
          transition={{ delay: 0.1 }}
        >
          <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
            Our Team
          </h3>
        </motion.div>
        <div className='flex flex-col sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 justify-center items-center'>
          <Profile
            image='/KevinProfile.png'
            name='Mr. Kevin Wong'
            titles={[
              'Executive Director',
              'Senior Behaviour Therapist',
              'FSCD Coordinator',
            ]}
          />
          <Profile
            image='/joannayuen.png'
            name='Ms. Joanna Yuen'
            titles={[
              'Registered Occupational Therapist',
            ]}
          />
          <Profile
            image='/matthewfiorentini.png'
            name='Mr. Matthew Fiorentini'
            titles={[
              'Registered Physiotherapist',
            ]}
          />
          <Profile
            image='/emilytse.png'
            name='Miss Emily Tse'
            titles={[
              'Certified Applied Behaviour Analyst/Behaviour Therapist',
            ]}
          />
          <Profile
            image='/tammarabehl.png'
            name='Ms Tammara Behl'
            titles={[
              'Behaviour Therapist',
              'Teacher',
            ]}
          />
          <Profile
            image='/LinkandLearnSimpleSilver.png'
            name='Speech Language Pathologist'
            titles={[
              'Please contact us to inquire about our certified Speech Language pathologists on staff.',
            ]}
          />
          <Profile
            image='/jadelee.png'
            name='Miss Jade Yee'
            titles={[
              'Developmental Specialist',
              'Behaviour Aide',
              'Teacher',
            ]}
          />
          <Profile
            image='/LinkandLearnSimpleSilver.png'
            name='Mr. Richard Eta Takang'
            titles={[
              'Developmental Specialist',
              'Behaviour Aide',
            ]}
          />
          <Profile
            image='/philipfrederic.png'
            name='Mr. Phillip Frederic'
            titles={[
              'Developmental Specialist',
              'Behaviour Aide',
              'Teacher',
            ]}
          />
          <Profile
            image='/sophialove.png'
            name='Miss Sophia Love'
            titles={[
              'Developmental/Behaviour Aide',
              'Respite Worker',
            ]}
          />
          <Profile
            image='/edwardwong.png'
            name='Mr. Edward Wong'
            titles={[
              'Developmental/Behaviour Aide',
              'Respite Worker',
            ]}
          />
          <Profile
            image='/LinkandLearnSimpleSilver.png'
            name='Miss Promise Amadi'
            titles={[
              'Pediatric Developmental Specialist',
              'Behaviour Aide',
              'Respite Worker',
            ]}
          />
          <Profile
            image='/LinkandLearnSimpleSilver.png'
            name='Miss Nicole Langan'
            titles={[
              'Behaviour Aide',
              'Respite Worker',
            ]}
          />
          <Profile
            image='/ishmaelgowralli.png'
            name='Mr. Ishmael Gowralli'
            titles={[
              'Senior Teacher',
              'Senior Pedagogical Specialist',
            ]}
          />
          <Profile
            image='/josephfernando.png'
            name='Dr. Joseph Fernando'
            titles={[
              'Senior Teacher',
              'Pedagogical Specialist',
            ]}
          />
          <Profile
            image='/iristsoi.png'
            name='Miss Iris Tsoi'
            titles={[
              'Special Needs Pedagogical Specialist ',
              'Teacher',
              'Music Therapist',
            ]}
          />
          <Profile
            image='/auroraanderson.png'
            name='Miss Aurora Anderson'
            titles={[
              'Teacher',
              'Behaviour Therapist',
            ]}
          />
          <Profile
            image='/posiolaku.png'
            name='Miss Posi Olaku'
            titles={[
              'Teacher',
              'Developmental Specialist',
            ]}
          />
          <Profile
            image='/LinkandLearnSimpleSilver.png'
            name='Miss Ada Li'
            titles={[
              'Teacher',
              'Behaviour Aide',
              'Respite Worker',
            ]}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Profiles;
